import {isNaN} from 'lodash'
export function countOmit(val){
  return isNaN(val)?val:val>10000?((Math.ceil(val/1000)/10).toFixed(1)+'W'):val;
}